import {BoxProps, Collapse, Stack} from '@mui/material'
import {useCallback} from 'react'
import {useTranslation} from 'react-i18next'

import {CollapsibleCard} from '../../../shared/components/CollapsibleCard'
import {PlannerFeature, PlannerLSSettingsKeys} from '../../../shared/enums'
import {usePersistingSettingState} from '../../../shared/hooks/usePersistingSettingState'
import {usePlannerFeature} from '../../../shared/hooks/usePlannerFeature'
import {StartRecalculationButton} from '../shared/StartRecalculationButton'

import {AnalyzeProductionPlanButton} from './AnalyzeProductionPlanButton'
import {OptimizerPlansTable} from './OptimizerPlansTable'

export const OptimizerPlansOverviewCard = (props: BoxProps) => {
  const {t} = useTranslation()

  const isOptimizerPlanAnalysisEnabled = usePlannerFeature(PlannerFeature.OptimizerPlanAnalysis)

  const [{isCardOpen}, setSettings] = usePersistingSettingState(
    PlannerLSSettingsKeys.OptimizerPageSettings,
    {isCardOpen: true}
  )

  const toggleIsMinimized = useCallback(() => {
    setSettings({isCardOpen: !isCardOpen})
  }, [setSettings, isCardOpen])

  return (
    <CollapsibleCard
      {...props}
      isCollapsed={!isCardOpen}
      onToggleCollapsed={toggleIsMinimized}
      title={t('optimizer.optimizedPlan')}
      headerContent={
        <Stack direction="row" spacing={1.5} sx={{justifyContent: 'flex-end'}}>
          {isOptimizerPlanAnalysisEnabled && <AnalyzeProductionPlanButton />}
          <StartRecalculationButton backgroundMode="light" />
        </Stack>
      }
    >
      <Collapse in={isCardOpen}>
        <OptimizerPlansTable />
      </Collapse>
    </CollapsibleCard>
  )
}
